import { render } from "./EraserToolsButton.vue?vue&type=template&id=42013ed8&scoped=true"
import script from "./EraserToolsButton.vue?vue&type=script&lang=js"
export * from "./EraserToolsButton.vue?vue&type=script&lang=js"

import "./EraserToolsButton.vue?vue&type=style&index=0&id=42013ed8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-42013ed8"]])

export default __exports__